'use strict';

var animations = require('../../../motion/features/animations.cjs');
var drag = require('../../../motion/features/drag.cjs');
var gestures = require('../../../motion/features/gestures.cjs');
var layout = require('../../../motion/features/layout.cjs');

const featureBundle = {
    ...animations.animations,
    ...gestures.gestureAnimations,
    ...drag.drag,
    ...layout.layout,
};

exports.featureBundle = featureBundle;
//# sourceMappingURL=feature-bundle.cjs.map
